import React from 'react';
import { Auto } from 'fw/forms';
import * as API from 'modules/app/API'

class NaicsCodeAutoWithCategories extends React.Component {

	NAICSCodeLoader = () => {
		return {
			url: API.App.url('/lookup/lookupNAICSCodeWithCategories'),
			params: {
				value: this.props.value
			}
		}
	}

	render() {
		return (
			<Auto
				{...this.props}
				menuWidth="400px"
				loader={this.NAICSCodeLoader}
				placeholder={this.props.placeholder} 
				maxLength={this.props.maxLength}
				/>
		)
	}
}

export default NaicsCodeAutoWithCategories;

// Mark this as a form component
NaicsCodeAutoWithCategories.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Search..."
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/naicsCodeAutoWithCategories/NaicsCodeAutoWithCategories.js